import { SettingsApi } from "apis/SettingsApi";

export async function LoadFilter<T>(key: string): Promise<T | undefined> {
  const value = await SettingsApi.GetStoreGroupSetting(key);
  return value?.data?.data?.jsonSettings ? JSON.parse(value.data.data.jsonSettings) : undefined;
}

export function SaveFilter<T>(key: string, value: T) {
  SettingsApi.SetStoreGroupSetting({ key, jsonSettings: JSON.stringify(value) }).then(() => {
    // Do nothing we've saved the filter
  });
}